import { PIXI } from '@colonist/pixi';
import { uiGameManager } from '../../../shared/scripts/EntryShared.ts';
import { openSubscriptionOverlayInsteadOfLinkInVariant } from '../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
import { UIPrivateAdController } from './UIPrivateAdController.ts';
import { UIAdElements } from './UIAdElements.ts';
import { UIAdBlockState } from './UIAdBlockState.ts';
import { UIAdBlockController } from './UIAdBlockController.ts';
import { AnalyticEventValue, AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { UIAIPAdController } from './UIAIPAdController.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIAdController } from '../../../shared/scripts/ui_ad/UIAdController.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { uiManager } from '../EntryHomepage.ts';
import { Scene } from '../ui_html/UISceneTypes.ts';
import { createDeferredPromise } from '@colonist/utils';
import { setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { UserSessionUtils } from '../../../shared/scripts/UserSessionUtils.ts';
export class UIWAdController extends UIAdController {
    createRemoveAdButtonActions() {
        if (this.adElements.removeAdInGameLeft == undefined) return;
        if (this.adElements.removeAdInGameRight == undefined) return;
        openSubscriptionOverlayInsteadOfLinkInVariant(this.adElements.removeAdInGameLeft);
        openSubscriptionOverlayInsteadOfLinkInVariant(this.adElements.removeAdInGameRight);
        setElementOnClick(this.adElements.removeAdInGameLeft, ()=>{
            const eventData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.InGameRemoveAdButtonLeft
            };
            void CA.sendAnalyticEvent(eventData);
        });
        setElementOnClick(this.adElements.removeAdInGameRight, ()=>{
            const eventData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.ABTestClickAnalytics,
                floatValue: AnalyticEventValue.InGameRemoveAdButtonRight
            };
            void CA.sendAnalyticEvent(eventData);
        });
    }
    async adBlockAction() {
        var _ClientUserState_userState;
        const adblockIsActive = this.adblockState.isAdblockActive;
        if (adblockIsActive) {
            if (!UIUtilsEjsVariables.showVliAdAtBottomInGame) this.aipAdController.stopRefreshing();
            UIWAdController.hideAllVLIAds();
            this.privateAdController.startRefreshing();
            return;
        }
        await ClientUserState.waitUntilFresh;
        const shouldShowPrivateAds = ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hideAds()) || UIUtilsEjsVariables.isUserOnDiscord || !UserSessionUtils.shouldShowLobbyAds();
        if (shouldShowPrivateAds) this.privateAdController.startRefreshing();
        this.toggleModeSelectorAdVisibility(shouldShowPrivateAds);
        if (!UIUtilsEjsVariables.showVliAdAtBottomInGame) this.aipAdController.startRefreshing();
    }
    async showLobbyVerticalAds() {
        await ClientUserState.waitUntilFresh;
        if (!UserSessionUtils.shouldShowLobbyAds()) return;
        if (this.adElements.containerMainPageRightTop != undefined) this.adElements.containerMainPageRightTop.style.display = 'block';
        if (this.adElements.containerMainPageRightMiddle != undefined) this.adElements.containerMainPageRightMiddle.style.display = 'block';
        if (this.adElements.containerMainPageRightBottom != undefined) this.adElements.containerMainPageRightBottom.style.display = 'block';
    }
    removeLobbyAds() {
        if (this.adElements.containerMainPageRightTop != undefined) this.adElements.containerMainPageRightTop.style.display = 'none';
        if (this.adElements.containerMainPageRightMiddle != undefined) this.adElements.containerMainPageRightMiddle.style.display = 'none';
        if (this.adElements.containerMainPageRightBottom != undefined) this.adElements.containerMainPageRightBottom.style.display = 'none';
    }
    showInGameAds() {
        if (PIXI.utils.isMobile.phone) return;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
        this.showRightInGameAd();
        this.showLeftInGameAd();
        this.handleBottomInGameAd();
    }
    hideInGameAds() {
        this.hideRightInGameAd();
        this.hideLeftInGameAd();
        this.handleBottomInGameAd();
    }
    toggleModeSelectorAdVisibility(shouldHide) {
        if (this.adElements.modeSelectorAd == undefined) return;
        this.adElements.modeSelectorAd.classList.toggle('hidden', shouldHide);
    }
    showRightInGameAd() {
        if (this.adElements.containerGameRight == undefined) return;
        this.adElements.containerGameRight.style.display = 'block';
    }
    showLeftInGameAd() {
        if (this.adElements.containerGameLeft == undefined) return;
        this.adElements.containerGameLeft.style.display = 'block';
    }
    hideRightInGameAd() {
        if (this.adElements.containerGameRight == undefined) return;
        this.adElements.containerGameRight.style.display = 'none';
    }
    hideLeftInGameAd() {
        if (this.adElements.containerGameLeft == undefined) return;
        this.adElements.containerGameLeft.style.display = 'none';
    }
    static hideAllVLIAds() {
        document.querySelectorAll('.adsbyvli').forEach((e)=>e.style.display = 'none');
    }
    handleBottomInGameAd() {
        if (this.adElements.containerGameBottomSmall == undefined && this.adElements.containerGameBottom == undefined) return;
        if (uiManager.sceneController.scene != Scene.Game) return;
        const show = uiGameManager.canvasController.responsiveController.canShowBottomAd();
        const bottomAdElement = UIUtilsEjsVariables.showVliAdAtBottomInGame ? this.adElements.containerGameBottom : this.adElements.containerGameBottomSmall;
        bottomAdElement.style.display = show ? 'block' : 'none';
    }
    static async initiatePopupActionFromUserState(isAdblockActive) {
        if (UIAdBlockController.shouldShowSoftBlockPopup(ClientUserState.userState, isAdblockActive) == true) {
            const promise = createDeferredPromise();
            UIAdBlockController.showDisableAdblockPopup(()=>{
                promise.resolve();
            }, 'dismissible');
            return promise;
        }
    }
    listenIfAdBlockStateChanges() {
        if (this.adblockState.isAdblockActive == true) return;
        const maxIntervals = 10;
        const msPerInterval = 1000;
        let intervalCount = 0;
        const adblockStateChangeInterval = setInterval(()=>{
            if (intervalCount >= maxIntervals) {
                clearInterval(adblockStateChangeInterval);
                return;
            }
            if (this.adblockState.isAdblockActive == true) {
                clearInterval(adblockStateChangeInterval);
                void this.adBlockAction();
                return;
            }
            intervalCount += 1;
        }, msPerInterval);
    }
    constructor(){
        super();
        this.adblockState = new UIAdBlockState();
        this.adblockController = new UIAdBlockController();
        this.adElements = new UIAdElements();
        this.privateAdController = new UIPrivateAdController(this.adElements);
        this.aipAdController = new UIAIPAdController(this.adElements);
        void this.adBlockAction();
        window.addEventListener('resize', ()=>{
            this.handleBottomInGameAd();
        });
        this.createRemoveAdButtonActions();
        if (this.adblockState.isAdblockActive == false) {
            this.listenIfAdBlockStateChanges();
        }
    }
}
